import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { PlusCircleIcon } from "@heroicons/react/solid";

import { useToggle } from "../../utils";

import EditHumanCirclesModal from "./EditHumanCirclesModal";
import Badge from "../../components/Badge";

import { setHumansFilterQuery } from "../../actions/humans";

const HumanCircles = React.memo(({ human }) => {
  const dispatch = useDispatch();
  const circles = useSelector((state) => state.circles);

  const [editingHumanCircles, toggleEditingHumanCircles] = useToggle(false);
  const circlesOfHuman = circles.filter((c) =>
    c.humanIds.find((h) => h === human.id)
  );

  return (
    <>
      <div className="text-left flex flex-wrap items-center gap-1">
        <span className="text-sm text-gray-500 relative top-0.5 pb-1">
          Circles:
        </span>
        {circlesOfHuman.map((c) => (
          <span key={c.id} className="cursor-pointer">
            <Badge
              onClick={() => {
                dispatch(
                  setHumansFilterQuery({ circle: c.id, searchTerm: "" })
                );
              }}
            >
              {c.name}{" "}
            </Badge>
          </span>
        ))}
        <PlusCircleIcon
          onClick={toggleEditingHumanCircles}
          className="h-6 w-6 inline cursor-pointer "
        />
      </div>
      {editingHumanCircles && (
        <EditHumanCirclesModal
          human={human}
          onClosed={toggleEditingHumanCircles}
        />
      )}
    </>
  );
});

HumanCircles.displayName = "HumanCircles";
HumanCircles.propTypes = {
  human: PropTypes.object.isRequired,
};
export default HumanCircles;
